/** A query string from the values that are set — undefined, null and '' are left out, never sent as text. */
export const toQuery = (parameters: Record<string, string | number | null | undefined>): string => {
  const query = new URLSearchParams();

  for (const [name, value] of Object.entries(parameters)) {
    if (value !== undefined && value !== null && value !== '') {
      query.set(name, String(value));
    }
  }

  const text = query.toString();

  return text.length > 0 ? `?${text}` : '';
};
